import React from 'react'
import ScirrelImg from '../../img/scrirrel.png'
import PortfolioImg from '../../img/portfolio.png'
import BXIVImg from '../../img/bxiv.jpg'
import BookingSolutions from '../../img/booking.jpg'
import ReenactmentMarket from '../../img/reenactmentmarket.jpg'
import { SiMongodb, SiReact, SiExpressvpn, SiNodedotjs, SiTailwindcss, SiAmazonaws, SiStripe, SiPostgresql } from "react-icons/si";
import { motion } from 'framer-motion'

const ProjectCard = ({ title, description, link, image, stack }) => (
  <motion.div
    className="bg-gray-800 rounded-xl shadow-md p-4 flex flex-col bg-mid-color justify-between transition hover:shadow-xl"
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.5 }}
  >
    <a href={link} target="_blank" rel="noreferrer" aria-label={`Open ${title}`}>
      <h3 className="text-xl font-semibold mb-2 hover:text-indigo-400 transition">{title}</h3>
    </a>
    <p className="text-gray-400 text-sm mb-4">{description}</p>
    <div className="flex flex-wrap gap-3 mb-4">
      {stack.map(({ icon: Icon, label }, i) => (
        <div key={i} className="flex items-center gap-2 text-gray-300 text-sm">
          <Icon className="text-2xl text-brand-color" />
          <span>{label}</span>
        </div>
      ))}
    </div>
    <a href={link} target="_blank" rel="noreferrer">
      <img
        src={image}
        alt={`${title} screenshot`}
        className="rounded-md h-60 w-full object-cover hover:opacity-80 transition"
      />
    </a>
  </motion.div>
)
const Home = () => {
  return (
    <>
    <div className='mh-50vh bg--color'>
      <div className="flex justify-center ">
        <div className="w-1/2.5 flex flex-col justify-center  items-center  mt-10 h-50vh">
          <h1 className="text-brand-color text-5xl md:text-8xl ">Calum Marshall</h1>
          <h2 className="text-light-color text-3xl text-center md:text-5xl ">My Portfolio and Projects</h2>
          <h3 className="text-light-color opacity-70 text-2xl text-center md:text-3xl ">Creator | Developer | Dweeb</h3>

        </div>

     
       
      </div>
      

    </div>
    <div className="py-20 bg-gray-900 text-white">
  <div className="max-w-6xl mx-auto px-4">
    <h2 className="text-3xl font-bold mb-4">Projects</h2>
    <p className="text-gray-400 mb-10 text-lg">You can find some of my projects below.</p>

    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
      <ProjectCard
        title="Booking Solutions UK"
        description="Web Design for Hotels, B&Bs and Retreats. I work with clients across the UK to improve their business' booking system and increase their revenue by avoiding alternative platform's high fees."
        link="https://bookingsolutions.uk"
        image={BookingSolutions}
        stack={[
          { icon: SiReact, label: 'React' },
          { icon: SiTailwindcss, label: 'TailwindCSS' },
        ]}
      />

      <ProjectCard
        title="Reenactment Market"
        description="A bespoke Marketplace for Historical Reenactment Vendors.  "
        link="https://reenactment.market"
        image={ReenactmentMarket}
        stack={[
          { icon: SiReact, label: 'React' },
          { icon: SiExpressvpn, label: 'Express' },
          { icon: SiPostgresql, label: 'Postgresql' },
          { icon: SiNodedotjs, label: 'Node.js' },
          { icon: SiAmazonaws, label: 'AWS' },
        ]}
      />

      <ProjectCard
        title="Britannia XIV"
        description="BritanniaXIV is a medieval reenactment charity focusing on the Scottish Wars of Independence."
        link="https://britanniaxiv.com"
        image={BXIVImg}
        stack={[
          { icon: SiReact, label: 'React' },
          { icon: SiExpressvpn, label: 'Express' },
          { icon: SiMongodb, label: 'MongoDB' },
          { icon: SiNodedotjs, label: 'Node.js' },
        ]}
      />

    </div>
  </div>
</div>
    </>
  )
}

export default Home